module.exports = __webpack_public_path__ + "img/avatar-01.8496dc5a.jpg";